module.exports = __webpack_public_path__ + "static/media/close-circle.257402f6.svg";